export function getRiskAssessment({ articles = 0, highThreat = 0, conflict = 0 } = {}) {
  const total = Math.max(1, Number.isFinite(articles) ? articles : 0);
  const severe = Math.max(0, Number.isFinite(highThreat) ? highThreat : 0);
  const conflictReports = Math.max(0, Number.isFinite(conflict) ? conflict : 0);
  const weightedShare = (0.7 * severe + 0.3 * conflictReports) / total;
  const score = Math.max(0, Math.min(100, Math.round(weightedShare * 800)));
  const defcon = score >= 80 ? 1 : score >= 60 ? 2 : score >= 40 ? 3 : score >= 20 ? 4 : 5;
  const band = score >= 80 ? 'CRITICAL' : score >= 60 ? 'HIGH' : score >= 40 ? 'ELEVATED' : score >= 20 ? 'GUARDED' : 'LOW';
  return { score, defcon, band };
}
